/* eslint no-unused-vars: 0 */

import exportModule from './export/export';

import components from './components';
import services from './services';
import storyDrawer from './story-drawer';
import StoriesController from './StoriesController';
import StandalonePitchFormController from './pitch-form/StandalonePitchFormController';
import listTemplate from './stories.list.html';
import pitchFormTemplate from './pitch-form/stories.newPitch.html';
import explainer from './explainer/refineExplainer';
import panels from './panels';
import resetSearch from './reset/resetSearch';
import savedSearchRedirect from './saved-search-redirect/savedSearchRedirect';

const module = angular.module('websked.stories.search', [
  'websked.stories.export'
]);

const toLoad = [
  StoriesController,
  StandalonePitchFormController,
  storyDrawer,
  explainer,
  components,
  services,
  panels,
  resetSearch,
  savedSearchRedirect
];

toLoad.forEach((fn) => fn(module));

function routes($stateProvider, routeConfigProvider) {
  const storiesViewParams = `{pname}&{tsort}&{tt}&{ts}&{tp}&{term}&{as}&{author}&{at}&
    {hed}&{slug}&{sourceId}&{pi}&{ps}&{ws}&{ct}&{sd}&{plan:any}&{child_plans}&{tbd}&
    {sort}&{starting}&{ending}&{groupby}&{sec:any}&{pl:any}&{plannedTimeAccuracy}&{quantity}&
    {so}&{content}&{live}&{pitchesOnly}&{tags}&{_refresh}&{websites}&{hier}&{distName}&{dist}`;

  $stateProvider
    .state('stories', {
      abstract: true,
      url: '/stories',
      template: '<div ui-view></div>',
      resolve: {
        distributors: [
          'distributorService',
          (distributorService) => distributorService.getByType('distributors')
        ],
        platforms: [
          'platformService',
          (platformService) =>
            platformService.getAll().then((platforms) => platforms)
        ]
      }
    })
    .state('stories.list', {
      url: `?${storiesViewParams}`,
      params: routeConfigProvider.createRouteParams(storiesViewParams),
      template: listTemplate,
      controller: 'StoriesController',
      data: {
        pageTitle: {
          de: 'Artikel',
          en: 'Stories',
          es: 'Artículos',
          fr: 'Articles'
        }
      },
      resolve: {
        enableRefresh() {
          return true;
        },
        $transitions: ['$transitions', ($transitions) => $transitions]
      }
    })
    .state('planning', {
      abstract: true,
      url: '/list',
      template: '<div ui-view></div>',
      resolve: {
        distributors: [
          'distributorService',
          (distributorService) => distributorService.getByType('distributors')
        ],
        platforms: [
          'platformService',
          (platformService) =>
            platformService.getAll().then((platforms) => platforms)
        ]
      }
    })
    .state('planning.list', {
      url: `?${storiesViewParams}`,
      params: routeConfigProvider.createRouteParams(storiesViewParams),
      template: listTemplate,
      controller: 'StoriesController',
      data: {
        pageTitle: 'LIST_VIEW'
      },
      resolve: {
        enableRefresh() {
          return true;
        },
        $transitions: ['$transitions', ($transitions) => $transitions]
      }
    })
    .state('stories.newPitch', {
      url: '/new-pitch?storyID&type',
      template: pitchFormTemplate,
      controller: 'StandalonePitchFormController',
      controllerAs: '$ctrl',
      data: {
        pageTitle: {
          de: 'Neu Pitch',
          en: 'New Pitch',
          es: 'Nueva Venta',
          fr: 'Nouvelle Soumission'
        }
      }
    })
    .state('pitchForm', {
      url: '/pitch-form?storyID&type',
      template: `<pitch-form ng-if="$ctrl.type && $ctrl.storyId"
                             type="$ctrl.type"
                             story-id="$ctrl.storyId"
                             platforms="$ctrl.platforms"
                             sites="$ctrl.sites"
                             excluded-destinations="$ctrl.excludedDestinations"
                             form-type="external"
                             submission-success="$ctrl.success(pitchData)">
                 </pitch-form>
                 <div class="flexbox flex-col flex-justify-center flex-align-center"
                      ng-if="!$ctrl.type || !$ctrl.storyId">
                   <h2>
                     {{ $ctrl.errorMessage }}
                   </h2>
                   <div class="pv1"
                        ng-if="$ctrl.errorMessage">
                    <button class="btn"
                            ng-click="$ctrl.closeModal()"
                            twp-translate>
                      CANCEL
                    </button>
                   </div>
                 </div>`,
      controller: 'StandalonePitchFormController',
      controllerAs: '$ctrl',
      data: {
        pageTitle: {
          de: 'Neu Pitch',
          en: 'New Pitch',
          es: 'Nueva Venta',
          fr: 'Nouvelle Soumission'
        }
      }
    })
    .state('savedSearches', {
      url: '/saved-searches/:id',
      component: 'savedSearchRedirect',
      data: {
        pageTitle: {
          de: 'Gespeicherte Suchen',
          en: 'Saved Searches',
          es: 'Búsquedas Guardadas',
          fr: 'Recherches Enregistrées',
          ja: '保存済み検索'
        }
      },
      resolve: {
        savedSearch: [
          '$transition$',
          'savedSearchService',
          ($transition$, savedSearchService) => {
            const id = $transition$.params().id;
            if (id) {
              return savedSearchService.getById(id).then(
                (response) => response,
                (response) => response
              );
            }
            return null;
          }
        ]
      }
    });
}

module.config(['$stateProvider', 'routeConfigProvider', routes]);
